import React from 'react';
import PropTypes from 'prop-types';

import RightPane from './RightPane';
import SettingsForm from './SettingsForm';
import * as BottomPane from './BottomPane';

import withToolsetPlaceholder from 'components/ToolsetPlaceholder';

const SamplingDistributionsComponent = props => (
  <div className="page-main__indent">
    <div className="flex">
      <div className="settings-width mb-15 mr-15">
        <SettingsForm />
      </div>

      {props.showRightAndBottomPanes &&
        <div className="graph-width mb-15">
          <RightPane />
        </div>
      }
    </div>

    {props.showRightAndBottomPanes &&
      <div className="mb-15">
        {props.parameterType === 'numerical' &&
          <BottomPane.Numerical />
        }

        {props.parameterType === 'categorical' &&
          <BottomPane.Categorical />
        }
      </div>
    }
  </div>
);

SamplingDistributionsComponent.propTypes = {
  showRightAndBottomPanes: PropTypes.bool.isRequired,

  parameterType: PropTypes.string
};

SamplingDistributionsComponent.defaultProps = {
  parameterType: null
};

export default withToolsetPlaceholder(
  SamplingDistributionsComponent
);
